import { API_DEV } from "constants/api";

import { header, handleAPIResult, serialize } from "utils";

export const statsService = {
  get,
  stats_tv,
};

function get(url, filters) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  const qs = (url.indexOf("?") === -1 ? "?" : "&") + serialize(filters);

  return new Promise((resolve, reject) => {
    fetch(API_DEV + url + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function stats_tv(filter = "") {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/statistics/count?indicator=tailgate&" + filter, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
